import { render, staticRenderFns } from "./UiTooltip.vue?vue&type=template&id=2f00a816&lang=pug&"
import script from "./UiTooltip.vue?vue&type=script&lang=js&"
export * from "./UiTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports